// extracted by mini-css-extract-plugin
export default {"toolTipArea":"Tooltipper_toolTipArea__YWviw","toolTipAreaLarge":"Tooltipper_toolTipAreaLarge__EnUst"};